import { Provider, Type } from '@angular/core';
import { SOL_PREFERENCE_STORE, SolPreferenceStore } from '../services/sol-preference-store';

export function provideSolPreferences(store: Type<SolPreferenceStore>): Provider[] {
  return [
    {
      provide: SOL_PREFERENCE_STORE,
      useExisting: store,
    },
  ];
}
